import React, { FC, ReactNode } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBanner, ModalFooter } from 'snacks-design-system';

export interface IPIEDialog {
  children?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  isOpen: Boolean;
  onClose?: () => void;
  onAfterClose?: () => void;
  size: 'small' | 'medium' | 'large';
  showOverlay?: Boolean;
  closeOnOutside?: Boolean;
  isCenter?: Boolean;
  setContentCenter?: Boolean;
  noContentPadding?: Boolean;
  modalHeader?: ReactNode;
  modalBanner?: ReactNode;
  modCustom?: Boolean;
  noPadding?: Boolean;
}

export const PIEDialog: FC<IPIEDialog> = ({
  children,
  isOpen,
  size,
  onClose,
  showOverlay,
  onAfterClose,
  closeOnOutside,
  isCenter,
  setContentCenter,
  noPadding,
  header,
  modCustom,
  modalBanner,
  footer,
}) => {
  return (
    <div>
      <Modal
        onAfterClose={onAfterClose}
        modPositionCenter={isCenter}
        modCenterContent={setContentCenter}
        onClose={onClose}
        isOpen={isOpen}
        modOverlay={showOverlay}
        size={size}
        modCloseOnOverlayClick={closeOnOutside}
      >
        {header ? <ModalHeader modCustom={modCustom}>{header}</ModalHeader> : null}
        {modalBanner ? <ModalBanner>{modalBanner}</ModalBanner> : null}

        {children ? <ModalContent modNoPadding={noPadding}>{children}</ModalContent> : null}
        {footer ? <ModalFooter>{footer}</ModalFooter> : null}
      </Modal>
    </div>
  );
};

export default PIEDialog;
